const { jsPDF } = require("jspdf"); // will automatically load the node version
import moment from "moment";
import { localDate, localDateTime, generateReportDatetime  } from "../tools/jsprocedure";

function convertTemp (temp, isCelcius) {
    return isCelcius ? temp.toFixed(1) : Number(Math.round(temp * 1.8 + 32 + 'e1') + 'e-1').toFixed(1);
}

function roiColor (color)  {
    switch (color) {
        case 1: {
            return "white";
        }
        case 2: {
            return "black";
        }
        case 3: {
            return "blue";
        }
        case 4: {
            return "yellow";
        }
        case 5: {
            return "green";
        }
    }
}

async function generatePdf(selectedImageData, newImageState, selectedAnimal, colorMapSelectedCode64, min_value, max_value, zoomValue, comment, reporter, languageSelected, isCelcius, t ) {
    const doc = new jsPDF({
        orientation: "landscape"
    });

    // TODO -  READ IMAGEin ACTIVE SCREEEN FROM MAIN IMAGE
    //var imageData = this.context.getImageData(x, y, 1, 1).data

    // Heading
    let infoRectX = 5;

    doc.text(t("VET-Viewer Report"), 140, 10);
    
    //Image detail:
    doc.setFontSize(10);
    doc.text(t("Image date: "), infoRectX, 12);
    doc.text(localDateTime(new Date(selectedImageData.acquisitiontime), languageSelected), infoRectX + 24, 12);
    doc.text(t("Creator: ") + reporter, infoRectX + 235, 16);

    // Reported created date
    doc.text(localDateTime(new Date(), languageSelected), 240, 12);


    // General info
    let infoRectY = 25;
    let infoRectHeight = 50;
    let infoRowX = infoRectX + 4;


    doc.rect(infoRectX, infoRectY, 90, infoRectHeight);
    doc.setTextColor("black");
    doc.setFontSize(10);
    doc.text(t("Animal name: "), infoRowX, infoRectY + 4);
    doc.text(selectedAnimal.name, infoRowX + 25, infoRectY + 4 );

    doc.text(t("Owner: "), infoRowX, infoRectY + 8);
    doc.text(selectedAnimal.owners[0].name, infoRowX + 25, infoRectY + 8);

    doc.text(t("Address: "), infoRowX, infoRectY + 12);
    doc.text(selectedAnimal.owners[0].address, infoRowX + 25, infoRectY + 12);

    doc.text(t("Phone: "), infoRowX, infoRectY + 16);
    doc.text(selectedAnimal.owners[0].phone, infoRowX + 25, infoRectY + 16);

    doc.text(t("Email: "), infoRowX, infoRectY + 20);
    doc.text(selectedAnimal.owners[0].email, infoRowX + 25, infoRectY + 20);

    let comWidth = infoRectX + 90;

    // Comments, notes,....
    doc.rect(comWidth, infoRectY, 195, infoRectHeight);
    doc.text(comment, comWidth + 2, infoRectY + 5);

    // calculate image %
    let sizex = selectedImageData.width ;
    let sizey = selectedImageData.height;


    let pageImageX = 160;
    let pageImageY = 120;

    let zoomValueNew = 1;
    let percentX = pageImageX / sizex;
    let percentY = pageImageY / sizey;

    if (percentX > percentY) {
        zoomValueNew = percentY;
    } else {
        zoomValueNew = percentX;
    }  

    let imageX = infoRectX;
    let imageY = infoRectY + 55;


    // draw image rectangle
    doc.rect(infoRectX, infoRectY + infoRectHeight + 5, 160, 120);

    // Thermal image
    doc.addImage(newImageState, "png", infoRectX, infoRectY + infoRectHeight + 5, sizex * zoomValueNew, sizey * zoomValueNew);

    // ROI-Area  with color on its own set color
    let rois = selectedImageData.rois;

    //rois.map((roi, index) => { 
    //    doc.circle(roi.x, roi.y, roi.radius + 5);
    //})

    //*******************************************************************


    rois.map((roi, i) => {
        let x = imageX + roi.x * zoomValueNew;
        let y = imageY + roi.y * zoomValueNew;
        let color = roiColor(roi.o_color);
        doc.setDrawColor(color)
        doc.circle(x, y, roi.radius * zoomValueNew, "S");
        doc.setTextColor(color);
        doc.setFontSize(Number(12 * (zoomValueNew + 0.2)).toFixed(2));
        doc.text(roi.label, x + 0.5 + roi.radius * zoomValueNew, y + 1 + roi.radius * zoomValueNew);

    });


    //*****************************************************************************************
    // Notes written over the image 
    let notes = selectedImageData.notes;
    doc.setFont("Calibri");
    //doc.setFontSize(10);
    doc.setDrawColor("white")

    notes.map((note, i) => {
        doc.setFillColor("white");
        doc.setTextColor("black");
        let x = Number(imageX + note.x * zoomValueNew).toFixed(2);
        let y = Number(imageY + note.y * zoomValueNew).toFixed(2);
        let width = Number(note.width * zoomValueNew).toFixed(2);
        let height = Number(note.height * (zoomValueNew)).toFixed(2);


        if (zoomValueNew <= 0.13) {
            doc.setFontSize(Number(note.notefontsize * (zoomValueNew + 0.2)).toFixed(2));
            if (note.notefontsize < 10) {
                var yText = Number(y) + Number(note.notefontsize * (zoomValueNew + 0.2) / 2);
            } else if (note.notefontsize > 10 && note.notefontsize <= 20) {
                var yText = Number(y) + Number(note.notefontsize * (zoomValueNew + 0.2) / 2.5);
            } else if (note.notefontsize > 20 && note.notefontsize <= 26) {
                var yText = Number(y) + Number(note.notefontsize * (zoomValueNew + 0.2) / 2.4);
            } else
                var yText = Number(y) + Number(note.notefontsize * (zoomValueNew + 0.2) / 3);
            var xText = Number(x) + Number(note.notefontsize * (zoomValueNew + 0.1) / 8);
        } else if (zoomValueNew > 0.13 && zoomValueNew < 0.30) {
            if (note.notefontsize < 10) {
                doc.setFontSize(Number(note.notefontsize * (zoomValueNew + 0.5)).toFixed(2));
                var yText = Number(y) + Number(note.notefontsize * (zoomValueNew + 0.2) / 1);
            } else if (note.notefontsize > 10 && note.notefontsize <= 20) {
                doc.setFontSize(Number(note.notefontsize * (zoomValueNew + 0.4)).toFixed(2));
                var yText = Number(y) + Number(note.notefontsize * (zoomValueNew + 0.2) / 1.5);
            } else if (note.notefontsize > 20 && note.notefontsize <= 26) {
                doc.setFontSize(Number(note.notefontsize * (zoomValueNew + 0.4)).toFixed(2));
                var yText = Number(y) + Number(note.notefontsize * (zoomValueNew + 0.2) / 1.4);
            } else {
                doc.setFontSize(Number(note.notefontsize * (zoomValueNew + 0.4)).toFixed(2));
                var yText = Number(y) + Number(note.notefontsize * (zoomValueNew + 0.2) / 2);
            }
            var xText = Number(x) + Number(note.notefontsize * (zoomValueNew + 0.1) / 10);
        } else {
            if (note.notefontsize < 10) {
                doc.setFontSize(Number(note.notefontsize * (zoomValueNew + 0.8)).toFixed(2));
                var yText = Number(y) + Number(note.notefontsize * (zoomValueNew + 0.2) / 1);
            } else if (note.notefontsize > 10 && note.notefontsize <= 20) {
                doc.setFontSize(Number(note.notefontsize * (zoomValueNew + 0.6)).toFixed(2));
                var yText = Number(y) + Number(note.notefontsize * (zoomValueNew + 0.2) / 1.3);
            } else if (note.notefontsize > 20 && note.notefontsize <= 26) {
                doc.setFontSize(Number(note.notefontsize * (zoomValueNew + 0.4)).toFixed(2));
                var yText = Number(y) + Number(note.notefontsize * (zoomValueNew + 0.2) / 1.4);
            } else { 
                doc.setFontSize(Number(note.notefontsize * (zoomValueNew + 0.8)).toFixed(2));
                var yText = Number(y) + Number(note.notefontsize * (zoomValueNew + 0.2) / 1.5);
            }

            var xText = Number(x) + Number(note.notefontsize * (zoomValueNew + 0.1) / 10);
        }


        doc.rect(x, y, width, height, "FD", { verticalalign: 'left' }).text(note.note, xText, yText, { align: 'left' });

    });


    //*****************************************************************************************

    // ColorMap
    doc.addImage(colorMapSelectedCode64, "png", infoRectX + 170, infoRectY + infoRectHeight + 5, 15, 120);


    doc.setFontSize(10);
    doc.setTextColor("white");

    // Print C / F temperature char
    isCelcius ?
        doc.text("\u00b0C", infoRectX + 170 + 10, infoRectY + infoRectHeight + 9)
        :
        doc.text("\u00b0F", infoRectX + 170 + 10, infoRectY + infoRectHeight + 9)
    let stepScale = (max_value - min_value ) / 12;
    let i = 0;
    let scale = min_value;

    do {
        doc.text(scale.toFixed(1), infoRectX + 170, infoRectY + infoRectHeight + 5 + 120 - i-2);
        scale = scale + stepScale;
        i = i+10;
    }
    while (scale <= max_value);



    let roiTableX = 200;
    let roiTableY = infoRectY + 65;
    let roiTableRow = 80;

    // Rect ROI Table
    doc.setDrawColor("black");
    doc.rect(roiTableX, roiTableY-10, 90, 120);
    
        //Roi - Heading
    doc.setTextColor("black");
    doc.text("ROI", roiTableX + 2, roiTableRow + 5);
    doc.text(t("Center"), roiTableX + 10, roiTableRow + 5);
    doc.text(t("Min"), roiTableX + 27, roiTableRow + 5);
    doc.text(t("Max"), roiTableX + 40, roiTableRow + 5);
    doc.text(t("Avg"), roiTableX + 55, roiTableRow + 5);
    doc.text(t("Diff"), roiTableX + 73, roiTableRow + 5);

    //let isCelcius = true;

    let roiTableI_x = roiTableX + 2 ;
    let roiTableI_Y = roiTableY + 2;


    let rowSeparator = 0;
    if (rois.length >= 30) {
        doc.setFontSize(8);
        rowSeparator = 3;
    } else if (rois.length > 20 && rois.length < 30)
        rowSeparator = 4;
    else if (rois.length > 12 && rois.length <= 20)
        rowSeparator = 5.5;
    else
        rowSeparator = 10;

    rois.map((roi, index) => {
        doc.text(roi.label, roiTableI_x, roiTableI_Y + rowSeparator * index);
        doc.text(convertTemp(roi.centertemp, isCelcius), roiTableI_x + 10, roiTableI_Y + rowSeparator * index);
        doc.text(convertTemp(roi.mintemp, isCelcius), roiTableI_x + 27, roiTableI_Y + rowSeparator * index);
        doc.text(convertTemp(roi.maxtemp, isCelcius), roiTableI_x + 40, roiTableI_Y + rowSeparator * index);
        doc.text(convertTemp(roi.avgtemp, isCelcius), roiTableI_x + 55, roiTableI_Y + rowSeparator * index);
        roi.deltatemp && doc.text(convertTemp(roi.deltatemp, isCelcius), roiTableI_x + 71, roiTableI_Y + rowSeparator * index);
    })

    //doc.save("report.pdf");
    return doc;
}

//const imageUrls = ["Thermidas_logo.png"];

async function savePdf(selectedImageData, newImageState, selectedAnimal, colorMapSelectedCode64, min_value, max_value, zoomValue, comment, reporter, languageSelected, isCelcius, t) {
    const multiPng = await generatePdf(selectedImageData, newImageState, selectedAnimal, colorMapSelectedCode64, min_value, max_value, zoomValue, comment, reporter, languageSelected, isCelcius, t);

    // generate dataURLString
    const dataURLString = multiPng.output("dataurlstring", "multiPng.pdf");
    //console.log(dataURLString);

    let datetime = generateReportDatetime(new Date(selectedImageData.acquisitiontime), languageSelected);
    let reportname = selectedAnimal.name + "_" + datetime + ".pdf";
    multiPng.output("save", reportname);

}

async function saveReportPDF(selectedImageData, newImageState, selectedAnimal, colorMapSelectedCode64, min_value, max_value, zoomValue, comment, reporter, languageSelected, isCelcius,t ) {
    savePdf(selectedImageData, newImageState, selectedAnimal, colorMapSelectedCode64, min_value, max_value, zoomValue, comment, reporter, languageSelected, isCelcius, t).then(console.log("Saved"));
}

export default saveReportPDF;